var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrosshair1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5278_1170)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 13.913,
    stroke: "#2D2926",
    strokeWidth: 2.6087
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.9999,
    cy: 20.0001,
    r: 1.73913,
    fill: "#2D2926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 1.73901V10.4347",
    stroke: "#2D2926",
    strokeWidth: 2.6087,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 29.5652V38.2608",
    stroke: "#2D2926",
    strokeWidth: 2.6087,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2607 20L29.5651 20",
    stroke: "#2D2926",
    strokeWidth: 2.6087,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4346 20L1.73892 20",
    stroke: "#2D2926",
    strokeWidth: 2.6087,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5278_1170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrosshair1);
export default __webpack_public_path__ + "static/media/crosshair 1.b0df016619fe6ab4a3e9d5478687830a.svg";
export { ForwardRef as ReactComponent };